import classes from './LoadingSpinner.module.css';

const LoadingSpinner = ({className, color}) => {
  const _className = `${color ==='orange' ? classes.orangeSpinner : classes.greenSpinner} ${className}`
  return <div className={_className}></div>;
}

export default LoadingSpinner;
